import { SIDEBAR } from './sidebar.constants'
import type { SidebarResizerProps } from './SidebarResizer.types'

/**
 * The sidebar's right edge (WAI-ARIA window splitter): drag it, or focus it
 * and use ←/→ (Shift for bigger steps), Home (icons only), End (widest) and
 * Enter or double-click (default width).
 */
export function SidebarResizer({ resize, label }: SidebarResizerProps) {
  return (
    <div
      className="sidebar-resizer"
      role="separator"
      aria-orientation="vertical"
      aria-label={label}
      aria-valuemin={SIDEBAR.rail}
      aria-valuemax={SIDEBAR.max}
      aria-valuenow={Math.round(resize.width)}
      tabIndex={0}
      data-dragging={resize.dragging || undefined}
      title={label}
      {...resize.handle}
    />
  )
}
